import type { SVGProps } from 'react';
const directionalArrowLeftTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M9.33149 4.53217C9.60152 4.80253 9.62229 5.22796 9.39381 5.52217L9.33149 5.59283L3.86989 11.0617L21.5361 11.0625C21.9498 11.0625 22.2852 11.3983 22.2852 11.8125C22.2852 12.1971 21.996 12.5141 21.6235 12.5575L21.5361 12.5625L3.86839 12.5618L9.33149 18.0322C9.60152 18.3025 9.62229 18.728 9.39381 19.0222L9.33149 19.0928C9.06146 19.3632 8.63656 19.384 8.3427 19.1552L8.27214 19.0928L1.53043 12.3428C1.2604 12.0725 1.23963 11.647 1.46812 11.3528L1.53043 11.2822L8.27214 4.53217C8.56467 4.23928 9.03896 4.23928 9.33149 4.53217Z"
      fill={props.color ?? '#000'}
      fillRule="evenodd"
    />
  </svg>
);
export default directionalArrowLeftTemplateOutline;
